export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-block mb-4">
              <span className="text-xl font-bold font-heading text-background-50 tracking-tight">
                探花<span className="text-primary-400">系列</span>
              </span>
            </a>
            <p className="text-sm leading-relaxed text-background-50/50 max-w-xs">
              探花系列 · 精品内容聚合平台。汇聚探花大神合集、探花一区精选、探花91社区与探花探花推荐，为探花迷打造一站式内容发现体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-full bg-background-50/10 hover:bg-primary-500/30 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm text-background-50/60"></i>
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-full bg-background-50/10 hover:bg-primary-500/30 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-telegram-line text-sm text-background-50/60"></i>
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-full bg-background-50/10 hover:bg-primary-500/30 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-link-m text-sm text-background-50/60"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '精选图文', href: '#cards' },
                { label: '排行榜', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '常见问答', href: '#faq' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">内容板块</h4>
            <ul className="space-y-2.5">
              {[
                { label: '探花精选', href: '#index' },
                { label: '探花一区', href: '#index' },
                { label: '探花91社区', href: '#index' },
                { label: '探花大神合集', href: '#index' },
                { label: '极品探花推荐', href: '#index' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              感谢所有合作伙伴对探花系列平台的支持。合作共赢，共同为探花迷提供更优质的内容服务体验。
            </p>
            <p className="text-xs text-background-50/30 mt-3">
              合作伙伴信息持续更新中
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/30">
            &copy; 2026 探花系列. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/30">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-background-50/50 transition-colors">服务条款</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-background-50/50 transition-colors">隐私政策</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-background-50/50 transition-colors">内容声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}